// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Kwmh","top":"styles_top__3S4G0"};